import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import TestSyllabusModal from "../../../shared/TestSyllabusModal/TestSyllabusModal";

import "./PaperListing.css";

import {
  fetchExamInstructionRequest,
  setTestDetails,
  setTestId,
  setTestType,
  setSelectedSetId ,
} from "../../../../../redux/exam/examSlice";
import { fetchAitsSyllabusRequest } from "../../../../../redux/aits/aitsSlice";

import GameficationMode from "../../../../tests/Dashboard/GameficationMode";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return "Invalid Date";

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const TestCard = ({ test, isPyq = false }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { plannerDetails } = useSelector((state) => state.examSlice);
  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
    selectedSetId,
  } = plannerDetails || {};

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showGameMode, setShowGameMode] = useState(false);

  const handleOpenSyllabus = () => {
    dispatch(
      fetchAitsSyllabusRequest({
        paperId: test.paper_id,
        plannerId: planner_id,
      })
    );
    setIsModalOpen(true);
  };
  const isLocked = new Date(test.a) > new Date();
  const handlePdfDownload = () => {
    if (!test.pdf) return;
    window.open(test.pdf, "_blank");
  };

const handleStart = () => {

  if (isLockedByPurchase) {
    history.push(`/package/${test.package_id}`);
    return;
  }

  if (isLocked) return;

  if (test.show_practice === 1) {
    setShowGameMode(true);
  } else {
    handleGameModeConfirm({
      selectedMode: "test",
      gamificationOn: false,
    });
  }
};


  /* -------------------------------
     After Mode Selection
  -------------------------------- */
  const handleGameModeConfirm = ({ selectedMode, gamificationOn }) => {
    const testId = test.test_id || test.paper_id;

    dispatch(setTestId(testId));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId: test.paper_id || testId,
      paperType,
      plannerId: planner_id,
      plannerTypeId: planner_type_id,
      categoryId: category_id || "",
      testId,
      // setId: selectedSetId,
      setId: test.set_id || selectedSetId || null, 
      planner_test_id: testId,

      practiceMode: selectedMode,
      gamificationOn,
       source: isPyq ? "yearwise" : "paperlisting", 
    };

    dispatch(setTestDetails(payload));

    dispatch(fetchExamInstructionRequest(payload));
    setShowGameMode(false);
    history.push("/TestInstruction");
  };

  const handleViewResult = () => {
    history.push("/analytics");
  };
//   const handleViewResult = () => {
//   const testId = test.test_id || test.paper_id;
// dispatch(setSelectedSetId(null));
//   const payload = {
//     paperId: test.paper_id || testId,
//     paperType,
//     plannerId: planner_id,
//     plannerTypeId: planner_type_id,
//     categoryId: category_id || "",
//     testId,
//    setId: null,
//     planner_test_id: testId,
//     source: isPyq ? "yearwise" : "paperlisting",
//   };

//   dispatch(setTestDetails(payload));

//   history.push("/analytics");
// };
  // ===== ACCESS TYPE (AITS ONLY) =====
  const isAits = !isPyq;

  const isPurchased = isAits && test.access_type === "Purchased";

  const isFree = isAits && test.free_paid === "Free";

  const isPremium = isAits && test.free_paid === "Paid" && !isPurchased;
  const isLockedByPurchase = isPremium && test.is_purchased === 0;

  return (
    <div className="test_card">
      <div className="testcard_header">
        <div className="left_section">
          {isPurchased && (
            <span className="purchased_tag">
              <img src={images.openlock_icon} alt="purchased" />
              Purchased
            </span>
          )}

          {!isPurchased && isFree && (
            <span className="free_tag">
              <img src={images.lockfree_icon} alt="free" />
              FREE
            </span>
          )}

          {!isPurchased && isPremium && (
            <span className="premium_tag">
              <img src={images.lock_icon} className="lock_icon" alt="premium" />
              PREMIUM
            </span>
          )}
          <span className="major_tag">
            {test.test_type || (isPyq ? "PYQ" : "AITS")}
          </span>
        </div>
      </div>

      <div className="test_title_container">
        <h3 className="test_title">{test.test_name || test.paper_name}</h3>
        <div className="test_date_row">
          <img src={images.calender_icon} className="calendar_icon" alt="" />
          <span>
            {formatDateTime(
              test.test_date || test.paper_date || test.start_date
            )}
          </span>
        </div>
      </div>

      <div className="rank_marks">
        <div className="combined_row">
          <div className="test_details_row">
            <div className="detail_box">
              <h4>Questions</h4>
              <p>{test.total_questions}</p>
            </div>
            <div className="detail_box">
              <h4>Duration</h4>
              <p>{test.test_duration_min || test.duration_mins} mins</p>
            </div>
            <div className="detail_box">
              <h4>Marks</h4>
              {/* <p>{test.max_marks}</p> */}
              <p>{test.max_marks}</p>
            </div>
          </div>
          {test.is_submited === 1 && (
            <div className="result_section_inline">
              <div className="stat score">
                <div className="stat-top">Score</div>
                <div className="stat-bottom">
                  {/* {test.attempted_questions}/{test.max_marks} */}
                  {test.attempted_questions}/
                  {test.max_marks ?? test.total_marks}
                </div>
              </div>
              <div className="stat rank">
                <div className="stat-top">Rank</div>
                <div className="stat-bottom">{test.rank || "-"}</div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="dotted_line"></div>

      <div className="bottom_content">
  
        <div className="bottom_links">
          {!isPyq && test.show_syllabus === 1 && (
            <span
              className="bottom_syllabus"
              // onClick={() => setIsModalOpen(true)}
              onClick={handleOpenSyllabus}
            >
              Syllabus
            </span>
          )}

          {/* PYQ → Download PDF */}
          {isPyq && test.pdf && (
            <span className="bottom_syllabus" onClick={handlePdfDownload}>
              Download
            </span>
          )}
        </div>
        {!isPyq && isModalOpen && (
          <TestSyllabusModal onClose={() => setIsModalOpen(false)} />
        )}

        {test.is_submited !== 1 ? (
         <button className="start_test_btn" onClick={handleStart}>
  {isLockedByPurchase || isLocked ? (
    <>
     <img src={images.LockedIcon} className="btn_lock_icon" alt="lock" />
      Locked
     
    </>
  ) : test.is_submited !== 1 &&
    ((test.is_start_test === 1 && test.is_submited === 0) ||
      (test.is_attempted === 1 && test.is_submited === 0)) ? (
    "Resume Test"
  ) : (
    "Start Test"
  )}
</button>
        ) : (
          <div className="completed_buttons">
            {test.is_reattempt === 1 && (
              <button className="reattempt_btn" onClick={handleStart}>
                Reattempt
                { test.user_attempt_count > 0
                  ? `(${test.user_attempt_count})`
                  : ""}
              </button>
            )}
            {test.is_submited === 1 && test.show_view_result === 1 && (
              <button className="view_result_btn" onClick={handleViewResult}>
                View Result
              </button>
            )}
          </div>
        )}
      </div>
      <GameficationMode
        isOpen={showGameMode}
        onClose={() => setShowGameMode(false)}
        onConfirm={handleGameModeConfirm}
        attemptMessage={test.attempt_message} 
      />
    </div>
  );
};

export default TestCard;
